export default __webpack_public_path__ + "static/media/372.e3c38b24.gif";